import { render, staticRenderFns } from "./AgendaItemsNavigationSwitcher.vue?vue&type=template&id=78976f36"
import script from "./AgendaItemsNavigationSwitcher.vue?vue&type=script&lang=js"
export * from "./AgendaItemsNavigationSwitcher.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports